<template>
  <v-card >
    <v-list>
      <v-list-item>

          <v-col >
            <v-card>
              <v-toolbar dense flat color="blue-grey lighten-5" height="50">
                <v-list-item-avatar>
                  <v-btn
                    color="blue-grey"
                    icon
                    outlined
                    small
                    @click="$router.go(-1)"
                  >
                    <v-icon>mdi-arrow-left-bold</v-icon>
                  </v-btn>
                </v-list-item-avatar>
                <v-container>
                  <v-toolbar-title class="subtitle-1"
                    >Datos del de/para</v-toolbar-title
                  >
                </v-container>
                <v-container class="d-flex justify-end">
                  <v-menu offset-y left>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" x-small outlined icon fab>
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list dense>
                      <v-list-item @click="modificarDepara = true">
                        <v-list-item-icon class="list-icon">
                          <v-icon class="icon-size">mdi-pencil</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title
                            >Modificar de/para</v-list-item-title
                          >
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="eliminarDepara = true">
                        <v-list-item-icon class="list-icon">
                          <v-icon class="icon-size" color="red darken-1"
                            >mdi-trash-can</v-icon
                          >
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>
                            <font color="#C00"> Eliminar de/para</font>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-container>
              </v-toolbar>

              <!-- Subir documentos -->
              <v-container>
                <documentosDeparaComponent :id="idDepara" />
              </v-container>
              <!-- Termina subir documentos -->
              <v-divider></v-divider>
              <v-container>
                <v-row>
                  <v-col md="5">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle
                          >Tipo documento:
                        </v-list-item-subtitle>
                        <v-list-item-title>De/para</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col md="4">
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-subtitle>Status:</v-list-item-subtitle>
                        <v-list-item-title>{{
                          depara.status
                        }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col md="3">
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-subtitle>Fecha:</v-list-item-subtitle>
                        <v-list-item-title>{{
                          formatoFecha(depara.fecha)
                        }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col md="5">
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-subtitle>De: </v-list-item-subtitle>
                        <v-list-item-title>{{ depara.de }} </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col md="6">
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-subtitle>Para:</v-list-item-subtitle>
                        <v-list-item-title>{{ depara.para }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col md="5">
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-subtitle>Capturó:</v-list-item-subtitle>
                        <v-list-item-title>{{ capturo }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col md="6">
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-subtitle
                          >Última modificación:</v-list-item-subtitle
                        >
                        <v-list-item-title>{{ modifico }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <br />
                  <v-col md="12">
                    <v-card-subtitle>Asunto: </v-card-subtitle>
                    <v-card-text>{{ depara.asunto }}</v-card-text>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-list-item>

    </v-list>

    <modificarDeparaComponent
      v-if="modificarDepara"
      :mostrar="modificarDepara"
      :depara="depara"
      @cancelar="modificarDepara = false"
      @deparaModificado="deparaModificado"
    />

    <mensajeEliminarDeparaComponent
      v-if="eliminarDepara"
      :mostrar="eliminarDepara"
      :idDepara="idDepara"
      @cancelar="eliminarDepara = false"
    />
  </v-card>

</template>

<script>
import {DateTime} from 'luxon';

import modificarDeparaComponent from "./modificarDepara.vue";
import mensajeEliminarDeparaComponent from "./eliminarDepara.vue";
import documentosDeparaComponent from "./documentos/documentos.vue";

import { cargarDeparaByIdService } from "./depara.service";

export default {
  name: "deparaTimeline",
  props: [],
  components: {
    modificarDeparaComponent,
    mensajeEliminarDeparaComponent,
    documentosDeparaComponent,
  },
  computed: {},
  watch: {},
  data: () => ({
    loading: false,
    idDepara: null,
    depara: [],
    de: "",
    capturo: "",
    modifico: "",
    modificarDepara: false,
    eliminarDepara: false,
  }),
  mounted() {
    this.idDepara = this.$route.params.id;
    this.cargarDepara();
  },
  methods: {
    async cargarDepara() {
      try {
        this.loading = true;

        const serverResponse = await cargarDeparaByIdService(this.idDepara);

        if(serverResponse.depara==null){
          this.$router.replace('/oficios/DePara?page=1&search=&filter=0')
        }
       
        this.loading = false;

        if (!serverResponse.ok) throw Error(serverResponse.mensaje);
        else {
          this.depara = serverResponse.depara;
          this.capturo = `${this.depara.captura.titulo} ${this.depara.captura.nombreCompleto}`;
          this.modifico = `${this.depara.modifico.titulo} ${this.depara.modifico.nombreCompleto}`;
        }
      } catch (error) {
        this.loading = false;
        this.$notificarError(error.message);
      }
    },
    formatoFecha(fecha){
      return fecha ? DateTime.fromSQL(fecha.split('T')[0]).toFormat('dd/MM/yyyy') : '';
      },
    deparaModificado(nuevoDepara) {
      this.depara = nuevoDepara;
      this.capturo = `${this.depara.captura.titulo} ${this.depara.captura.nombreCompleto}`;
      this.modifico = `${this.depara.modifico.titulo} ${this.depara.modifico.nombreCompleto}`;
      this.modificarDepara = false;
    },
  },
};

// Icono de file
// mdi-file-document
// mdi-file-outline
</script>

<style>
</style>
